import type { InvoicesRepository } from '@/core/invoices'
import type { UseCase } from '@/core/shared'

export const payPaymentsInvoice: UseCase<InvoicesRepository, 'payPaymentsInvoice'> = repository => {
  return async (invoiceId: number) => {
    await repository.payPaymentsInvoice(invoiceId)
  }
}
